import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class PlanDeEmbarque {
  static adaptToBackendInsert (values = {}, fechaEstimadaArribo) {
    const {
      nombreCorto,
      agenciaMaritima,
      giro,
      fechaAnuncio
    } = values

    return {
      buque: nombreCorto,
      agenciaMaritima: agenciaMaritima,
      giro: giro || null,
      fechaAnuncio: fechaAnuncio,
      fechaEstimadaDeArribo: fechaEstimadaArribo
    }
  }

  static adaptToBackendInsertBodega (values = {}) {
    const {
      buque,
      fechaDeReferencia,
      bodega,
      cereal,
      cerealVariedad,
      paisDestino,
      peso
    } = values

    return {
      buque: buque,
      fechaDeReferencia: fechaDeReferencia,
      bodega: bodega,
      cereal: cereal,
      cerealVariedad: cerealVariedad || 'UNDEF',
      paisDestino: paisDestino,
      pesoTotal: peso
    }
  }

  static adaptToBackendUpdateDetail (values = {}) {
    const {
      bodega,
      cereal,
      cerealVariedad,
      paisDestino,
      peso
    } = values

    return {
      bodega: bodega,
      cereal: cereal,
      cerealVariedad: cerealVariedad || 'UNDEF',
      paisDestino: paisDestino,
      pesoTotal: peso
    }
  }

  static async insertarPlanDeEmbarque (values, fechaEstimadaArribo) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackendInsert(values, fechaEstimadaArribo)
    const promise = axios.post(`plan_de_embarque_ingreso`, { valores: { ...valores } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data[0])
  }

  static async obtenerPlanDeEmbarque (fecha) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_plan_de_embarque?r=` +
      `{"clave":{"fecha_de_referencia:"${fecha}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static async obtenerPlanDeEmbarqueActivo () {
    const axios = getAxiosInstance()
    const promise = axios.get('consulta_plan_de_embarque_activo_listado')
    return promise
      .then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static async updatePlanDeEmbarque (fecha, newBuque, oldBuque, agencia) {
    const axios = getAxiosInstance()
    const promise = axios.put(`plan_de_embarque_ingreso`, { valores: { buque: newBuque, agencia_maritima: agencia }, clave: { fecha_de_referencia: fecha, buque: oldBuque } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static async deletePlanDeEmbarque (fecha, buque) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`plan_de_embarque_ingreso?r=` +
      `{"clave":{"fecha_de_referencia": "${fecha}", "buque": "${buque}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static async getPlanDeEmbarqueBodega (fecha) {
    const axios = getAxiosInstance()
    const promise = axios.get(`plan_de_embarque_bodega?r={"clave": {"fecha_de_referencia": "${fecha}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static async updatePlanDeEmbarqueBodega (fecha, bodega, buque, paisDestino, formValues) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackendUpdateDetail(formValues)
    const promise = axios.put(`plan_de_embarque_bodega_ingreso`, { valores: { ...valores }, clave: { fecha_de_referencia: fecha, bodega: bodega, buque: buque, pais_destino: paisDestino } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static async obtenerDetalleBodega (fecha, bodega) {
    const axios = getAxiosInstance()
    const promise = axios.get(`plan_de_embarque_detalle_bodega?r={"clave": {"fecha_de_referencia": "${fecha}", "bodega": "${bodega}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data[0])
  }

  static async insertarPlanDeEmbarqueBodega (values) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackendInsertBodega(values)
    const promise = axios.post(`plan_de_embarque_bodega_ingreso`, { valores: { ...valores } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static async deletePlanDeEmbarqueBodega (fecha, bodega, buque, paisDestino) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`plan_de_embarque_bodega_ingreso?r=` +
    `{"clave":{"fecha_de_referencia": "${fecha}", "bodega": "${bodega}", "buque": "${buque}", "pais_destino": "${paisDestino}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static async deletePlanDeEmbarqueBodegaCompleto (fecha, buque) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`plan_de_embarque_bodega_ingreso_completo?r=` +
    `{"clave":{"fecha_de_referencia": "${fecha}", "buque": "${buque}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }
}

export default PlanDeEmbarque
